export const about = {
    uk: {
        aboutHeader: "ПРО КУРС",
        goalHeadingGrey: "НАША МЕТА",
        goalHeadingBlock: "Швидкий шлях до розуміння та вільного спілкування англійською",
        goalBodyText: "Для проходження курсу необхідно мати базові знання англійської мови на рівні A1. Курс не призначений для підготовки до іспитів A2, B1 або B2 — наразі ми працюємо над створенням відповідних програм. \n\n В основі курсу лежить кілька ключових ідей:",
        goalUnorderedList: [
            "Вивчивши 1050 найуживаніших слів, ви зможете розуміти майже все в повсякденних ситуаціях і вільно висловлювати свої думки англійською.",
            "Сформувавши звичку виконувати невеликі завдання щодня, ви досягнете справжнього прориву у вивченні англійської мови.",
            "Опанувавши щонайменше 90% матеріалу цього курсу, ви зможете впевнено розуміти, читати та спілкуватися англійською у повсякденному житті."
        ],
        firstColumnWrapper: [
            {
                columnHeader: "ВИВЧАЙ СЛОВА",
                columnBodyText: " Рекомендуємо пройти всі слова в уроці і позначити ті, які ви вже знаєте (сподіваємося, їх буде багато!). Потім поставте собі мету вивчати 5–7 нових слів на день, п’ять днів на тиждень. Обирайте ті техніки, які підходять саме вам: повторення, вивчення в контексті, активне відтворення, асоціації або занурення.",
                learnMoreTo: "/vocabulary",
                learnMoreText: "Дізнатися більше..."
            },
            {
                columnHeader: "БУДУЙ ГРАМАТИКУ",
                columnBodyText: "Обов’язково розберіться з відмінностями між трьома основними групами часів в англійській мові: Simple, Continuous та Perfect. Зверніть увагу: знання лише часів Simple охоплює приблизно 60–70% повсякденного спілкування. Додавши Continuous, ви охопите ще близько 20%, а Perfect допоможе завершити загальну картину. Також важливо добре опанувати й інші базові теми.",
                learnMoreTo: "/grammar",
                learnMoreText: "Дізнатися більше..."
            },
            {
                columnHeader: "ЧИТАЙ ВІРНО",
                columnBodyText: "Читання — це перший крок у відпрацюванні словникового запасу та граматики, і водночас найлегший. Не поспішайте: уважно читайте кожен текст, намагайтеся зрозуміти його зміст, звертайте увагу на незнайомі слова та вчіться правильно їх вимовляти. \nЧитайте щодня якомога більше й не обмежуйтеся лише текстами з цього курсу.",
                learnMoreTo: "/reading",
                learnMoreText: "Дізнатися більше..."
            }
        ],
        statsItems: [
            { value: 30, label: "УРОКІВ" },
            { value: 1050, label: "СЛІВ" },
            { value: 150, label: "ОГОЛОШЕНЬ І НАПИСІВ" },
            { value: 120, label: "ТЕКСТІВ ДЛЯ ЧИТАННЯ І СЛУХАННЯ" },
        ],
        secondColumnWrapper: [
            {
                columnHeader: "СЛУХАЙ І РОЗУМІЙ",
                columnBodyText: " Під час роботи з текстами цього курсу ви можете в будь-який момент натиснути \"Пауза\" або \"Повтор\" — те, що, на жаль, неможливо зробити в реальному житті. Проте ви завжди можете попросити співрозмовника говорити повільніше або повторити сказане. Дивіться фільми англійською, слухайте радіо та якомога більше спілкуйтеся з людьми — і ви здивуєтеся, як швидко з’являється прогрес за умови регулярної практики.",
                learnMoreTo: "/listening",
                learnMoreText: "Дізнатися більше..."
            },
            {
                columnHeader: "ГОВОРИ ВПЕВНЕНО",
                columnBodyText: "Найкраще навичка говоріння відпрацьовується через діалоги — і в цьому курсі у вас є для цього ідеальна можливість: 30 розмов із викладачем. Окрім цього, на вас чекають 30 текстів, які ви практикуватимете в усному мовленні англійською. Теми для розмов охоплюють більшість сфер повсякденного життя. Говоріння — найскладніша частина курсу, але опанувавши її, ви отримаєте величезну впевненість у собі.",
                learnMoreTo: "/speaking",
                learnMoreText: "Дізнатися більше..."
            },
            {
                columnHeader: "ПОЄДНАЙ УСЕ РАЗОМ",
                columnBodyText: "Звісно, ви можете вивчати словниковий запас, граматику, читання, аудіювання та говоріння окремо, але найефективніший підхід — скористатися опцією \"Мій прогрес\", яка поєднує всі ці компоненти в 30 уроків. Кожен із них містить граматичну тему з трьома вправами, 35 нових слів, текст для читання, два аудіотексти, один діалог і один текст для усної практики англійською.",
                learnMoreTo: "/myprogress",
                learnMoreText: "Дізнатися більше..."
            }
        ],
    },
    en: {
        aboutHeader: "About",
        goalHeadingGrey: "OUR GOAL",
        goalHeadingBlock: "Your Quick Path to Understanding and Speaking English",
        goalBodyText: "To take this course, learners should have basic English knowledge at the A1 level. This course is not designed to prepare students for A2, B1, or B2 exams — we are currently working on developing those programs. \n\nThere are a few key ideas behind this course:",
        goalUnorderedList: [
            "If you learn the 1,050 most common words, you’ll be able to understand almost everything in everyday situations and express your thoughts freely.",
            "If you develop the habit of doing small assignments daily, it will lead to a real breakthrough in your English learning.",
            "If you master at least 90% of the material in this course, you’ll be able to understand, read, and speak English confidently in everyday life."
        ],
        firstColumnWrapper: [
            {
                columnHeader: "LEARN WORDS",
                columnBodyText: " We recommend going through all words in the lesson and marking those you already know (hopefully, there will be many!). Then set a goal to learn 5–7 new words a day, five days a week. Choose the techniques that suit you best — repetition, context, active recall, association, or exposure.",
                learnMoreTo: "/vocabulary",
                learnMoreText: "Learn More..."
            },
            {
                columnHeader: "BUILD GRAMMAR",
                columnBodyText: "Be sure to understand the differences between the three main English tenses: Simple, Continuous, and Perfect. Note this — knowing just the Simple tenses alone covers around 60–70% of everyday communication! Add the Continuous tense, and you’ll cover another 20%, while the Perfect tense completes the rest. \nAlso, make sure to get on top of the other basic topics as well.",
                learnMoreTo: "/grammar",
                learnMoreText: "Learn More..."
            },
            {
                columnHeader: "READ WITH SKILL",
                columnBodyText: "Reading is the first step in practicing your vocabulary and grammar — and it’s the easiest one! Take your time to read carefully and understand each text, noting unfamiliar words and learning to pronounce them correctly. \nRead a lot every day, and don’t limit yourself to the texts in this course alone.",
                learnMoreTo: "/reading",
                learnMoreText: "Learn More..."
            }
        ],
        statsItems: [
            { value: 30, label: "LESSONS" },
            { value: 1050, label: "WORDS" },
            { value: 150, label: "READING SIGNS AND EXPRESSIONS" },
            { value: 120, label: "TEXTS TO READ AND LISTEN" },
        ],
        secondColumnWrapper: [
            {
                columnHeader: "LISTEN TO UNDERSTAND",
                columnBodyText: " You have the convenience of pressing Pause or Replay for the texts in this course — something that, unfortunately, isn’t possible in real life. However, you can always ask someone to speak more slowly or repeat what they said. Watch movies in English, listen to the radio, and talk to people as much as you can! You’ll be surprised how quickly you progress with consistent practice.",
                learnMoreTo: "/listening",
                learnMoreText: "Learn More..."
            },
            {
                columnHeader: "SPEAK WITH CONFIDENCE",
                columnBodyText: "Speaking is best mastered through dialogues — and in this course, you have the perfect opportunity: 30 conversations with your teacher!  In addition, there are 30 texts you’ll practice speaking in English. The conversational topics cover most areas of everyday life. Speaking is the most challenging part of the course, but once you master it, it will give you tremendous confidence!",
                learnMoreTo: "/speaking",
                learnMoreText: "Learn More..."
            },
            {
                columnHeader: "BRING IT ALL TOGETHER",
                columnBodyText: "You can certainly learn Vocabulary, Grammar, Reading, Listening, and Speaking separately, but the most effective way is to use the My Progress option, which combines them all. Each of the 30 lessons includes a grammar topic with three exercises, 35 new words to learn, a reading text, two listening texts, one dialogue, and one text to speak in English.",
                learnMoreTo: "/myprogress",
                learnMoreText: "Learn More..."
            }
        ],
    }
}